import { useState, useEffect } from 'react';
import styles from './W_SelectItem.module.css';
import A_SelectItem from '@/components/A_Atoms/A_SelectItem/A_SelectItem';
import A_SelectItemList from '@/components/A_Atoms/A_SelectItemList/A_SelectItemList';
import cn from 'classnames';

interface W_SelectItemProps {
  options?: string[];
  defaultLabel?: string;
  size?: 'thin' | 'wide';
  onSelect?: (selectedValue: string) => void;
  value?: string;
}

export default function W_SelectItem({
  options = ['Россия', 'США', 'Германия', 'Франция', 'Китай'],
  defaultLabel = 'Страна',
  size = 'thin',
  onSelect,
  value,
}: W_SelectItemProps) {
  const [isOpened, setIsOpened] = useState(false);
  const [selectedLabel, setSelectedLabel] = useState(value || defaultLabel);

  useEffect(() => {
    if (value && value.length > 0) {
      setSelectedLabel(value);
    } else {
      setSelectedLabel(defaultLabel);
    }
  }, [value, defaultLabel]);

  const handleToggle = () => {
    setIsOpened(!isOpened);
  };

  const handleSelect = (option: string) => {
    setSelectedLabel(option);
    setIsOpened(false);
    onSelect?.(option);
  };

  return (
    <div className={styles.wrapper}>
      <A_SelectItem
        label={selectedLabel}
        size={size}
        onClick={handleToggle}
        isOpened={isOpened}
      />
      {isOpened && (
        <div className={cn(styles.list_wrapper, styles[size])}>
          {options.map((option, index) => (
            <A_SelectItemList
              key={index}
              text={option}
              size={size}
              onClick={() => handleSelect(option)}
              isActive={selectedLabel === option}
            />
          ))}
        </div>
      )}
    </div>
  );
}
